import { ref, computed } from 'vue'

export const copaLoading = ref(true)
export const levelAccess = ref(null)

export const tierList = ref([])

export const comparationItems = ref([])
export const filters = ref(['Tudo', 'Zona', 'Bottler'])
export const activeFilter = ref('Tudo')
export const filtersLoading = ref(true)

export const enablers = ref([])

export const summaryCards = ref([])
export const summaryCardsLoading = ref(true)

export const availableFilters = ref({
  zones: true,
  bottlers: true,
})

export const filterModel = ref({
  tier: 1,
  type_a: false,
  type_b: false,
  zona: '',
  fabricante: '',
})

export const filterParams = computed(() => {
  const { tier, type_a, type_b, zona, fabricante } = filterModel.value
  const fabTierType = type_a === type_b ? '' : type_a ? 'A' : 'B'

  return {
    fab_tier: tier,
    fab_tier_type: fabTierType,
    fab_zone: zona?.fab_zone || '',
    fab_code: fabricante?.fab_code || '',
    bottler: fabricante?.fab_name || '',
    both_tier_types: type_a && type_b,
  }
})

export const evolutionSeries = ref([])
export const evolutionSeriesLoading = ref(true)

export const shouldRemoveDynamicColumns = ref(false)

export const quickWinsHighlightsData = ref([])
export const quickWinsHighlightsLoading = ref(false)
